import angular from 'angular';

let NewsDetailController = function ($filter, $mdDialog, $scope, $state, $timeout, News, Toast, State, City) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  if ($ctrl.id) $ctrl.hasNews = true
  $ctrl.search = '';
  $ctrl.searchState = '';

  $timeout(function(){
    angular.element(document.querySelector('.input-search-state')).on('keydown', function (ev) {
        ev.stopPropagation();
      });
  }, 500)

  angular.extend($ctrl, {
    clearForm, handleSave,
    onChangeState, handleDelete, clearSearch
  });

  activate();

  function activate() {
    clearForm();

    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);

    let id = $ctrl.id;

    $ctrl.uiState = 'LOADING';

    loadResource(id)
      .then(response => {

        simulateImageLoadProgress();
        $ctrl.states = response[0];
        if (response[1]) {
          $ctrl.newsItem = response[1];
          if($ctrl.newsItem.state_id) {
            onChangeState($ctrl.newsItem.state_id)
          }
          $ctrl.filter.isEnabled = !$ctrl.newsItem.is_for_all_users;
          $ctrl.filter.gender = $ctrl.newsItem.gender;
          $ctrl.filter.state_id = $ctrl.newsItem.state_id;
          $ctrl.filter.city_id = $ctrl.newsItem.city_id;
          $ctrl.filter.user_profile_type = $ctrl.newsItem.user_profile_type;

        }
        $ctrl.uiState = 'COMPLETE';
      })
      .catch(err => {
        console.log('err:', err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearForm(form) {
    $ctrl.newsItem = {};
    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;
    $ctrl.filter = {}
    $ctrl.search = '';
    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function clearSearch() {
    $ctrl.search = ''
  };

  function handleDelete(newsItem, event) {
    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('news-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('news-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        News
          .destroy(newsItem)
          .then(response => {
            Toast.success($filter('translate')('news-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('news.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, newsItem) {
    newsItem.image_base64 = $ctrl.myCroppedImage;

    if (!form.$valid || ((!newsItem.image_base64 && !newsItem.image_uri) || !newsItem.content || newsItem.content.trim().length < 12)) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    let count = newsItem.content.search(/"color:/), count2 = newsItem.content.search(/color=/);

    while(count > -1){
        const startIdx = newsItem.content.search(/"color:/) + 1;
        const endIdx = newsItem.content.substring(startIdx, startIdx + 35).search(/;/) + 1;
        const styleColor = newsItem.content.substring(startIdx, startIdx + endIdx)
        newsItem.content = newsItem.content.replaceAll(styleColor, '')
        count = newsItem.content.search(/"color:/)
    }

    while(count2 > -1){
        console.log(count2)
        const startIdx = newsItem.content.search(/color=/);
        const endIdx = newsItem.content.substring(startIdx, startIdx + 20).search("\">") + 1;
        const styleColor = newsItem.content.substring(startIdx, startIdx + endIdx)
        newsItem.content = newsItem.content.replaceAll(styleColor, '')
        count2 = newsItem.content.search(/color=/)
    }

    $ctrl.saving = true;
    
    if($ctrl.id && $ctrl.filter.isEnabled){
      for(const [k, v] of Object.entries($ctrl.filter)){
        newsItem[k] = v;
      }
      delete newsItem.filter
      newsItem.state_id = newsItem.state_id.filter(i => i.length > 0)
    }
    else if ($ctrl.filter.isEnabled) {
      $ctrl.filter.state_id = $ctrl.filter.state_id.filter(i => i.length > 0)
      newsItem.filter = $ctrl.filter
    }

    News
      .save(newsItem)
      .then(response => {
        Toast.success($filter('translate')('news-detail-save-success'));
        $ctrl.newsItem = response;
        $ctrl.myImage = '';
        $ctrl.myCroppedImage = '';
        $ctrl.fileName = undefined;
        $ctrl.saving = false;
        $state.go('news.list');
      })
      .catch(err => {
        Toast.error($filter('translate')('common-save-error'));
        console.log('err:', err);
        $ctrl.saving = false;
      });
  }

  function onChangeState(stateIdArr) {
    if (stateIdArr.length !== 0) {
      const states =  stateIdArr.filter(i => i)

      $ctrl.filter.city_id = null;
      $ctrl.loadingCities = true;
      City
        .index({
          state_id: states,
          limit: 1000000
        })
        .then(cities => {
          $ctrl.cities = cities;
          $ctrl.loadingCities = false;
        })
        .catch(err => {
          console.log('err:', err);
          $ctrl.loadingCities = false;
        }).finally(()=> {
          angular
          .element(document.querySelector('.input-search-city'))
          .on('keydown', function (ev) {
            ev.stopPropagation();
          });
        });
      }
      
      if (stateIdArr && stateIdArr.length > 1) {
        $ctrl.search = "";
        $ctrl.filter.city_id = null;
        $ctrl.cities = [];
      }
  }

  // Local functions

  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      console.log('no file added!');
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
        '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
        '  <md-dialog-content>' +
        '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' +
        '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' +
        '    </div>' +
        '' +
        '    <ui-cropper' +
        '      ng-show="isDoneLoading === true"' +
        '      on-load-done="isDoneLoading = true"' +
        '      image="myImage"' +
        '      area-type="rectangle"' +
        '      aspect-ratio="1.6744186047"' +
        '      init-max-area="true"' +
        '      chargement="loadingText"' +
        '      result-image-size="{w: 720,h: 430}"' +
        '      result-image="myCroppedImage" canvas-scalemode="true">' +
        '    </ui-cropper>' +
        '  </md-dialog-content>' +
        '  <md-dialog-actions' +
        '     ng-show="isDoneLoading === true">' +
        '    <md-button ng-click="cancel()">' +
        '      Cancelar' +
        '    </md-button>' +
        '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
        '      Feito' +
        '    </md-button>' +
        '  </md-dialog-actions>' +
        '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function (myCroppedImage) {
        $ctrl.myCroppedImage = myCroppedImage;
        $ctrl.myImage = '';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function DialogController($scope, $mdDialog, $filter) {
    "ngInject";
    $scope.loadingText = $filter('translate')('common-loading');
    $scope.myImage = $ctrl.myImage;
    $scope.myCroppedImage = $ctrl.myCroppedImage;

    $scope.hide = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function (myCroppedImage) {
      $mdDialog.hide(myCroppedImage);
    }
  }

  function loadResource(id) {

    let promises = [];

    promises.push(State.listStatesWithClient());
    if (id) {
      promises.push(News.show(id));
    }

    return Promise.all(promises);
  }

  function simulateImageLoadProgress() {
    $ctrl.loadingImage = true;
    $timeout(function () {
      $ctrl.loadingImage = false;
    }, 1000);
  }
}

NewsDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'News', 'Toast', 'State', 'City'];

export default NewsDetailController;



// WEBPACK FOOTER //
// ./client/app/components/news/news-detail.controller.js